import { useEffect, useState, useRef } from "react";
import styles from "./kb.module.scss"
import Knowledgegr from '../../styles/images/knowledgetest.svg'
import Workflow from '../../styles/images/workflowu.svg'
import Recordings from '../../styles/images/recordingloader.svg'
import { navigateToTicketing, openContactPage } from "../../base/utils";
const Knowledgebaseupgrade = ({ page }: { page?: string }) => {
    console.log('page>>>>>>>>>', page)
    const open = () => {
        navigateToTicketing()
    }
    return (
        <>
            <div className={`boxWhite ${styles.boxtes}`}>
                <h3>{page}</h3>
                <div className={styles.basest}>
                    <div className={styles.topbsmai}>
                        {page == 'Knowledge base' &&
                            <div className={styles.lefttobar}>
                                <h3>Unlock Knowledge base</h3>
                                <p>Unlock instant access to helpful articles, give agents faster answers, and reduce resolution time with a smarter support system. Empower your team to resolve issues confidently.</p>
                                <div className={styles.contactsale}>
                                    <button onClick={openContactPage}>Contact Sales</button>
                                    {/* <button onClick={open}>Upgrade</button> */}
                                </div>
                            </div>}
                        {/* workflow */}
                        {page === 'Workflow' &&
                            <div className={styles.lefttobar}>
                                <h3>Unlock Workflow</h3>
                                <p>Automate repetitive tasks, build smart flows, and boost your team’s efficiency with seamless workflow automation. Let your operations run smoothly on autopilot.</p>
                                <div className={styles.contactsale}>
                                    <button onClick={openContactPage}>Contact Sales</button>
                                    {/* <button onClick={open}>Upgrade</button> */}
                                </div>
                            </div>}
                        {/* Recordings */}
                        {page === 'Recording' &&
                            <div className={styles.lefttobar}>
                                <h3>Unlock Recordings</h3>
                                <p>Replay calls anytime, improve call quality, and coach agents effectively with real conversation insights. Build a transparent, high-performance call experience.</p>
                                <div className={styles.contactsale}>
                                    <button onClick={openContactPage}>Contact Sales</button>
                                    {/* <button onClick={open}>Upgrade</button> */}
                                </div>
                            </div>}
                        {/* Internal Chat */}
                        {page === 'Internal chat and BroadCast' &&
                            <div className={styles.lefttobar}>
                                <h3>Unlock Internal chat and BroadCast</h3>
                                <p>Replay calls anytime, improve call quality, and coach agents effectively with real conversation insights. Build a transparent, high-performance call experience.</p>
                                <div className={styles.contactsale}>
                                    <button onClick={openContactPage}>Contact Sales</button>
                                    {/* <button onClick={open}>Upgrade</button> */}
                                </div>
                            </div>}
                        <div className={styles.rightobar}>
                            {page == 'Knowledge base' && <img src={Knowledgegr} alt="" />}
                            {/* workflow */}
                            {page === 'Workflow' && <img src={Workflow} alt="" />}
                            {/* Recordings */}
                            {page === 'Recording' && <img src={Recordings} alt="" />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}
export default Knowledgebaseupgrade